import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const DocumentDownloadLinkWrapper = styled.div``;

export const FilterWrapper = styled.div`
  margin-bottom: ${spacing(3)};
`;
